import React, { useContext,useState, useEffect } from "react";
import { Form, Button, Row, Col, Modal } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SessionContext } from "../SessionProvider";

const FareMaster = (props) => {
   const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);
  const [formData, setFormData] = useState({
    Fare: "",
    UptoDistance: "",
    Status: "",
    session_id : selectedSessionId
  });
 
  const [errors, setErrors] = useState({
    Fare: "",
    UptoDistance: "",
  });

  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [sessionYear, setSessionYear] = useState([]);

  console.log("props data sh == ",props)
  useEffect(() => {
    async function getSessions() {
      try {
        const sessions = await schoolApi.fetchSessions();
        console.log("sessions data == ",sessions)
        if (sessions.success) {
          setSessionYear(sessions.result);
        } else {
          setSessionYear([]);
        }
      } catch (err) {
        toast.error("An error occurred while fetching sessions.");
        setSessionYear([]);
      }
    }
    getSessions();
  }, []);

  console.log("props.fareData == ",props.fareData)
  console.log("selectedSessionId",selectedSessionId)
  useEffect(() => {
   
    if (props.isUpdateMode && props.fareData) {
      setFormData({
        Fare: props.fareData.fare || "",
        UptoDistance: props.fareData.uptodistance || "",
        Status: props.fareData.status || "",
        session_id : props.fareData.session_id ? props.fareData.session_id : selectedSessionId
      });
      setIsUpdateMode(true);
    } else {
      if (props.btnName === "Create Fare") {
        setFormData({
          Fare: "",
          UptoDistance: "",
          Status: "",
          session_id : selectedSessionId
        });
        setIsUpdateMode(false);
      } else if (props.btnName === "Update Fare") {
        setFormData({
          Fare: props.fareData.fare || "",
          UptoDistance: props.fareData.uptodistance || "",
          Status: props.fareData.status || "",
          session_id : props.fareData.session_id ? props.fareData.session_id : selectedSessionId
        });
        setIsUpdateMode(true);
      }
    }
  }, [props.fareData, props.isUpdateMode, props.btnName]);
 


  const validateForm = () => {
   
    const newErrors = {};
    let isValid = true;

    if (formData.Fare.trim() === "") {
      isValid = false;
    }

    if (formData.Status.trim() === "") {
      isValid = false;
    }

    if (formData.session_id.trim() === "") {
      isValid = false;
    }

    if (formData.UptoDistance.trim() === "") {
      isValid = false;
    }
    if (isValid === false) toast.error("Missing required fields");

    setErrors(newErrors);
    return isValid;
  };


  const handleUpdate = async () => {
    if (!validateForm()) return;

    try {
     
      const fareIdToUpdate = props.fareData.id;
      const updatedFareData = { ...formData };
      const updatedFare = await schoolApi.updateFareMaster(
        fareIdToUpdate,
        updatedFareData
      );
     
      if (updatedFare) {
       
        toast.success(updatedFare.message);

        props.handleCloseModal();

      }
    } catch (error) {
     
      return toast.error(error.response.data.message);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
   console.log("handleSubmit == ",formData)
    if (!validateForm()) return;

    try {
      if (isUpdateMode) {
       
        handleUpdate();
      } else {
        const createdFare = await schoolApi.createFaremaster(formData);
       
        if (createdFare.message) {
         
          toast.success(createdFare.message);
          props.onFareCreated();
        }
      }
    } catch (error) {
     
      return toast.error(error.response.data.message);
    }
  };

  return (
    <div>
      <Modal
        show={props?.show}
        centered
        className="modal-dialog-scrollable"
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton onClick={props?.handleCloseModal}>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {}
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Fare Amount</Form.Label>
                <Form.Control
                  type="phone"
                  name="Fare Amount"
                  placeholder="Enter Fare"
                  value={formData.Fare}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      Fare: e.target.value.replace(/\D/g, ""),
                    })
                  }
                  required
                />
                {}
              </Form.Group>
            </Col>
            <Col md={6}>
              {" "}
              <Form.Group>
                {}
                <Form.Label>Status</Form.Label>
                <div>
                  <Form.Select
                    name="Status"
                    value={formData.Status}
                    onChange={(e) =>
                      setFormData({ ...formData, Status: e.target.value })
                    }
                    required
                  >
                    <option value="">--Select Status--</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">InActive</option>
                  </Form.Select>
                </div>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={6}>
              {" "}
              <Form.Group>
                <Form.Label>Upto Distance (Km)</Form.Label>
                <Form.Control
                  type="phone"
                  name="UptoDistance"
                  placeholder="Enter Distance"
                  value={formData.UptoDistance}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      UptoDistance: e.target.value.replace(/\D/g, ""),
                    })
                  }
                  required
                />
                {}
              </Form.Group>
            </Col>
            <Col lg={6}>
              <Form.Group>
                <Form.Label
                  className="form-view-label"
                  htmlFor="formBasicSession"
                >
                  Session
                </Form.Label>
                <Form.Select
                  required
                  name="session_id"
                  value={formData.session_id}
                  disabled={isUpdateMode}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      session_id: e.target.value,
                    })
                  }
                >
                  <option value="">-- Select Session --</option>
                  {sessionYear.map((session) => (
                    <option key={session.id} value={session.id}>
                      {session.year}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          {}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props?.handleCloseModal}>
            Cancel
          </Button>
          <div>
            {isUpdateMode ? (
              <Button variant="primary" onClick={handleUpdate}>
                Update
              </Button>
            ) : (
              <Button type="button" variant="primary" onClick={handleSubmit}>
                {}
                Save
              </Button>
            )}
          </div>
          {/* <Button variant="primary" onClick={''}>
                    Save
                </Button> */}
        </Modal.Footer>
      </Modal>
      {}
      <ToastContainer />
    </div>
  );
};

export default FareMaster;
